import React, { useState } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { observer } from 'mobx-react';
import IconPicker from '../../../icon-picker/icon-picker';
import { CQAppConstant } from '../../../../app-constants';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps {
    selectedTemplateName: string;
    updateViewSourceComponentConfig: Function;
    key: string;
    fieldInfo: IFieldData;
}

const GridIcon = (props: IProps) => {
    const templateConfigCtrl: GridTemplateConfigurationController = new GridTemplateConfigurationController();
    const templateObj = CQMasterDataStore.OutputConfig.getStoreData(props.selectedTemplateName);
    const updateIconName = (iconClassName: any) => {
        props.updateViewSourceComponentConfig(CQAppConstant.ICON_NAME, iconClassName);
        templateConfigCtrl.updateFieldValue('iconName', iconClassName, props.selectedTemplateName);
    }
    return (
        <div className="slds-form-element">
            <label className="slds-form-element__label">{props.fieldInfo.name}</label>
            <IconPicker
                key= {props.key}
                name={props.fieldInfo.name}
                value={templateObj['iconName']}
                updateIconName={updateIconName}
            ></IconPicker>
        </div>
    )
}

export const GridComponentIcon = observer(GridIcon);